<template>
  <section v-if="quote" id="licencias" class="seats-card">
    <div class="seats-card__info">
      <div class="seats-card__icon"><i class="el-icon-user"></i></div>
      <div>
        <p class="seats-card__title">Licencias de usuario adicionales</p>
        <p class="seats-card__desc">
          Agrega más personas a tu equipo sin cambiar de plan. Cada licencia
          cuesta lo mismo que tu plan {{ quote.plan_name }} ({{ periodLabel }})
          y se renueva junto con él.
        </p>
        <p class="seats-card__usage">
          Tu plan permite <strong>{{ quote.users_limit }}</strong> usuario(s)
          <template v-if="quote.extra_seats">
            · incluye {{ quote.extra_seats }} licencia(s) adicional(es)
          </template>
        </p>
      </div>
    </div>

    <div class="seats-card__buy">
      <label class="seats-card__label">Cantidad</label>
      <el-input-number
        v-model="quantity"
        :min="1"
        :max="50"
        size="medium"
        @change="refreshQuote"
      />
      <div class="seats-card__price">
        <span>{{ quantity }} × ${{ quote.unit_price.toFixed(2) }}</span>
        <span>+ IVA ${{ quote.tax.toFixed(2) }}</span>
        <strong>Total ${{ quote.total.toFixed(2) }}</strong>
      </div>
      <p v-if="quote.ends_at" class="seats-card__note">
        Válidas hasta el {{ endsAt }}, con tu suscripción actual.
      </p>
      <button
        class="btn md__btn-primary seats-card__btn"
        :disabled="paying"
        @click="buy"
      >
        {{ paying ? "Redirigiendo…" : "Comprar licencias" }}
      </button>
    </div>
  </section>
</template>

<script>
import payService from "../services/payService";

export default {
  name: "ExtraSeatsCard",
  data: () => ({ quote: null, quantity: 1, paying: false }),
  computed: {
    periodLabel() {
      return this.quote && this.quote.billing_period === "annual"
        ? "anual"
        : "mensual";
    },
    endsAt() {
      return this.quote && this.quote.ends_at
        ? new Date(this.quote.ends_at).toLocaleDateString("es-EC")
        : "";
    }
  },
  mounted() {
    // Solo propietario o administrador pueden comprar licencias.
    if (this.$store.getters.myRole === "member") return;
    const fromQuery = Number(this.$route.query.licencias);
    if (fromQuery > 0) this.quantity = Math.min(50, fromQuery);
    this.refreshQuote();
  },
  methods: {
    async refreshQuote() {
      try {
        const { data } = await payService.getSeatsQuote(this.quantity);
        this.quote = data && data.success ? data.data : null;
        if (this.quote && this.$route.hash === "#licencias") {
          this.$nextTick(() => this.$el.scrollIntoView({ behavior: "smooth" }));
        }
      } catch {
        // Sin plan vigente o usuarios ilimitados: no se ofrece.
        this.quote = null;
      }
    },
    async buy() {
      this.paying = true;
      try {
        const { data } = await payService.paySeatsPp({
          quantity: this.quantity
        });
        if (data && data.success && data.data) {
          location.href = data.data;
          return;
        }
        this.$notifications.error({
          message: "No pudimos iniciar el pago. Intenta de nuevo."
        });
      } catch {
        // el interceptor ya muestra el motivo
      }
      this.paying = false;
    }
  }
};
</script>

<style scoped lang="scss">
.seats-card {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  justify-content: space-between;
  align-items: flex-start;
  background: #fff;
  border: 1.5px solid #e6e8f0;
  border-radius: 10px;
  padding: 24px;
  margin-top: 32px;
  font-family: "Plus Jakarta Sans", sans-serif;

  &__info {
    display: flex;
    gap: 16px;
    flex: 1 1 360px;
  }

  &__icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    border-radius: 10px;
    background: rgba(62, 207, 180, 0.15);
    color: #1d9e75;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
  }

  &__title {
    margin: 0 0 6px;
    font-size: 17px;
    font-weight: 700;
    color: #2d2b55;
  }

  &__desc,
  &__usage,
  &__note {
    margin: 0 0 6px;
    font-size: 14px;
    color: #6b6a86;
    line-height: 1.5;
  }

  &__buy {
    flex: 0 1 280px;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  &__label {
    font-size: 13px;
    font-weight: 600;
    color: #2d2b55;
    margin: 0;
  }

  &__price {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 14px;
    color: #555a75;

    strong {
      font-size: 18px;
      color: #2d2b55;
    }
  }

  &__btn {
    width: 100%;
    border-radius: 10px;
  }
}
</style>
